import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from 'react';
import './TS_Overlay.scss';
import { _className } from '../../utils/tools.js';
export class TS_Overlay extends React.Component {
    render() {
        if (!this.props.showOverlay)
            return this.props.children;
        const overlayChild = _jsx("div", { className: "ts-overlay__child", onClick: this.props.onClickOverlay, onContextMenu: this.props.onClickOverlay, children: this.props.children });
        return _jsxs(_Fragment, { children: [_jsx("div", { className: _className('ts-overlay', this.props.className), onClick: this.props.onClickOverlay, onContextMenu: this.props.onClickOverlay, onMouseMove: e => e.stopPropagation(), onMouseOver: e => e.stopPropagation(), onMouseEnter: e => e.stopPropagation(), onMouseLeave: e => e.stopPropagation(), onMouseOut: e => e.stopPropagation(), children: !this.props.flat && overlayChild }), this.props.flat && overlayChild] });
    }
}
//# sourceMappingURL=TS_Overlay.js.map